// ── cohort-tab-collection-shared: bounded tab adapters (no urlSync) ───────────

import type { CollectionFilterDef } from "@vjal/ui";

import type { CoachingSessionDto } from "../../../services/coaching-dtos";
import { sessionDisplayTitle } from "../../sessions/sessions-helpers";

export const COHORT_TAB_PAGE_SIZE = 25;

export type SessionScopedRow = { session_id?: string } & Record<string, unknown>;

export function buildCohortSessionFilterDefs(
  sessions: CoachingSessionDto[]
): CollectionFilterDef<SessionScopedRow>[] {
  return [
    {
      id: "session_id",
      label: "Session",
      type: "select",
      placeholder: "Select session",
      getValue: (row) => row.session_id ?? "",
      options: sessions.map((session) => ({
        value: session.id,
        label: sessionDisplayTitle(session.title, session.id)
      }))
    }
  ];
}

export function cohortSessionFilterInitialState(activeSessionId: string): { filters: { session_id: string } } {
  return { filters: { session_id: activeSessionId } };
}